import { REACT_APP_API_BASE } from '../config';
import LocationHandler from '../components/districts/helpers/ui/location-handler';
import Popup from '../components/districts/helpers/ui/popup';

export const createUnitsService = (fetch, maps) => ({
    /**
     * Fetch units for a specific district type
     * @param {string} type - The district type
     * @param {Array} features - Optional array of features to filter units by
     * @returns {Promise<Array>} - Array of units
     */
    fetchUnits: async (type) => {
        let url = `${REACT_APP_API_BASE}/salesdistrict/units/${type}`;
        const res = await fetch(url);
        return res.json();
    },

    /**
     * Toggle units visibility on the map
     * @param {Object} params - Parameters for toggling units
     * @param {Object} params.map - Google Maps instance
     * @param {Object} params.maps - Google Maps API
     * @param {Array} params.units - Array of units to display
     * @param {boolean} params.isVisible - Whether units should be visible
     * @param {boolean} params.disableFitBounds - Whether to disable auto-fitting bounds
     * @param {Function} params.onUnitsLoaded - Callback when units are loaded
     * @param {Function} params.onLoadingComplete - Callback when loading is complete
     */
    toggleUnitsVisibility: async ({
        map,
        maps,
        units,
        isVisible,
        disableFitBounds,
        onUnitsLoaded,
        onLoadingComplete
    }) => {
        if (isVisible) {
            await LocationHandler.createLocations({
                map,
                maps,
                units,
                disableFitBounds,
                onClick: async (clickedUnits) => {
                    if (onUnitsLoaded) {
                        onUnitsLoaded({ units: clickedUnits.units });
                    }
                },
                onLoadingComplete: () => {
                    if (onLoadingComplete) {
                        onLoadingComplete();
                    }
                }
            });
        } else {
            LocationHandler.removeMarkers();
        }
    },

    /**
     * Create a popup for units
     * @param {Object} params - Parameters for creating popup
     * @param {Object} params.maps - Google Maps API
     * @param {Array} params.units - Array of units to display in popup
     * @param {Function} params.fetch - Fetch function for API calls
     * @returns {Object} - Popup instance
     */
    createUnitsPopup: ({ maps, units, fetch }) => {
        return Popup({
            fetch,
            maps,
            units
        });
    }
}); 